<template>
    <div class="order-box-left">
        <div class="top-search item">
            <div class="label">订单筛选</div>
            <div style="width:100%; margin-top:8px">
                <vs-button @click="emptySearch" type="border" size="small" class="search-btn">清空</vs-button>
                <vs-button @click="handleSearch" type="border" size="small" class="search-btn query-btn">查询</vs-button>
            </div>
        </div>
        <div class="order-number item">
            <div class="label">买家类型</div>
            <v-select v-model="searchData.buyerType" :options="buyerTypes" :reduce="buyer => buyer"
                      placeholder="请输入买家类型" class="select-wrap">
                <div slot="no-options">暂无选项</div>
            </v-select>
        </div>
        <div class="order-number item">
            <div class="label">买家名称</div>
            <!--   remainInputValue 回车保留val -->
            <search-input
                ref="bookmarkAutoSuggest"
                :autoFocus="false"
                :data="buyerOptions"
                placeholder="请输入买家名称"
                inputClassses="buyer-full"
                show-action
                show-pinned
                hideGroupTitle
                background-overlay
                remainInputValue
                showName="name"
                @input="searchInputSuggest"
                @selected="addSelectBuyer"/>
            <!-- <vs-input v-model="searchData.buyer" style="margin-top:5px" class="form-item" placeholder="请输入买家名称" v-validate="'required'" /> -->

        </div>
        <div class="order-number item">
            <div class="label">订单编号</div>
            <vs-input v-model="searchData.orderNo" style="margin-top:5px" class="form-item" placeholder="请输入订单编号"
                      v-validate="'required'"/>
        </div>
        <div class="timer item">
            <div class="label">订单时间</div>
            <flat-pickr style="margin-top:5px" :config="flatPickerConfig" v-model="searchData.fromDate"
                        placeholder="开始时间" @on-change="onChange"/>
            <flat-pickr style="margin-top:10px" :config="flatPickerConfig" v-model="searchData.toDate"
                        placeholder="结束时间" @on-change="onChange"/>
        </div>
        <vs-collapse ref="collapse" class="collapse item">
            <vs-collapse-item>
                <div style="font-size: 14px;" slot="header"><span class="label">订单状态</span></div>
                <ul class="centerx" >
                    <li style="height:30px" v-for="(item, index) in orderStatusList" >
                        <vs-checkbox v-model="searchData.orderStatus" :vs-value="item.value">{{item.label}}</vs-checkbox>
                    </li>
                </ul>
            </vs-collapse-item>

            <vs-collapse-item>
                <div style="font-size: 14px" slot="header"><span class="label">订单渠道</span></div>
                <ul class="centerx">
                    <li style="height:30px" v-for="(item, index) in orderWayList" :key="index">
                        <vs-checkbox v-model="searchData.orderWay" :vs-value="item.value">{{ item.label }}</vs-checkbox>
                    </li>
                </ul>
            </vs-collapse-item>
        </vs-collapse>
    </div>
</template>

<script>
import store from '../store.js';
import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';
import {Mandarin} from 'flatpickr/dist/l10n/zh.js';
import SearchInput from '@/modules/wms-manage/components/searchInput.vue';
import {OrderApi} from '@/modules/server-api/commodity-sys/order';

export default {
    components: {
        flatPickr, SearchInput
    },
    props: {
        buyerTypes: {
            type: Array
        },
        fromDate: {
            type: String
        },
        toDate: {
            type: String
        }
    },
    mixins: [store],
    data() {
        return {
            searchData: {
                buyer: '', //买家名称id
                buyerName: '',//买家名称
                buyerType: '', //买家类型
                orderNo: '', // 查询的订单编号
                fromDate: '',
                toDate: '',
                orderStatus: [],
                orderWay: [],
                dealerTypeList: [],
                isTab: false,
                tabIndex: 0,
            },
            buyerOptions: [], //模糊搜索买家名称
            orderSearchInfo: [], //查询缓存
            searchTime: '',
            flatPickerConfig: {
                locale: Mandarin //日期控件中文
            },
            // buyerTypeOptions: [
            //     {id: '1', label: '总部'},
            //     {id: '2', label: '省代'},
            //     {id: '3', label: '地代'},
            //     {id: '4', label: '零售商'}
            // ],
            buyerTypeOptions: this.buyerTypes,
        };
    },
    async mounted() {
        console.log(this.buyerTypeOptions)
        // 详情返回时，把查询条件回显到页面上
        let searchInfo = sessionStorage.getItem('searchData') //本地存储的搜索info
        let data = JSON.parse(searchInfo) //本地存储的搜索info
        console.log('查询条件1', data)
        if (data) {
            this.searchData = {
                orderNo: data.orderNo,
                fromDate: data.fromDate,
                toDate: data.toDate,
                orderStatus: data.orderStatus,
                orderWay: data.orderWay,
                buyer: data.buyer,
                buyerType: data.buyerType,
                dealerTypeList: data.dealerTypeList,
            }
            this.$refs['bookmarkAutoSuggest'].searchQuery = data.buyerName;
            console.log('id:', data.buyer, 'name:', data.buyerName)
        } else {
            this.searchData.fromDate = this.fromDate;
            this.searchData.toDate = this.toDate;
        }
        // console.log('this.searchData',this.searchData)
        // console.log('2collapse', this.$refs.collapse);
        await this.getOrderWayList();
        await this.getStatusList()
        console.log('2collapse', this.orderStatusList)
        // this.$nextTick(() => {
        //     if (this.$refs.collapse.$children) {
        //         this.$refs.collapse.$children.forEach(v => {
        //             v.toggleContent();
        //         });
        //     }
        // });
    },
    methods: {
        handleSearch() {
            let searchData = this.searchData;
            console.log('查询项', searchData, this.buyerTypes);
            console.log('buyers ', searchData.buyerType ? [searchData.buyerType] : this.buyerTypes)
            this.$emit('handleSearch', {
                buyer: searchData.buyer,
                buyerName: searchData.buyerName,
                buyerType: searchData.buyerType,
                dealerType: searchData.dealerType,
                dealerTypeList: searchData.buyerType,
                fromDate: searchData.fromDate,
                isTab: false,
                orderNo: searchData.orderNo,
                orderStatus: searchData.orderStatus,
                orderWay: searchData.orderWay,
                supplierType: searchData.supplierType,
                toDate: searchData.toDate,
                tabIndex: searchData.tabIndex,
            });
        },
        refreshBuyerType(buyerType, tabIndex) {
            if (buyerType) {
                this.buyerTypeOptions = buyerType.map((item) => {
                    return item;
                });
                console.log('调用子组件', this.buyerTypeOptions);
            } else {
                this.buyerTypeOptions = this.buyerTypes;
            }
            this.searchData.tabIndex = tabIndex;
            this.searchData.buyerType = '';
        },
        onChange(val) {
            this.$emit('onChangeTime');
        },
        // 模糊搜索买家名称
        async searchInputSuggest(e) {
            this.buyerOptions = []
            this.searchData.buyer = e === '' ? '' : this.searchData.buyer;
            let suggest = e.trim()
            // let suggest = e == 'undefined' ? '': e.trim()
            // let thisSearchTime = new Date().getTime();
            // this.searchTime = thisSearchTime;
            let res = await OrderApi.getBuyerName({search: suggest});
            // if(thisSearchTime >= this.searchTime){
            this.buyerOptions = res.result;
            // }
        },
        // 选择买家
        addSelectBuyer(item) {
            this.searchData.buyer = item.id
            this.searchData.buyerName = item.name
        },
        // 清空筛选条件
        emptySearch() {
            this.searchData = {
                buyer: '', //买家名称
                buyerType: '', //买家类型
                orderNo: '', // 查询的订单编号
                fromDate: '',
                toDate: '',
                orderStatus: [],
                orderWay: []
            }
            this.$refs['bookmarkAutoSuggest'].searchQuery = '';
            this.handleSearch()
        },
        // 清空筛选条件
        emptyOrderSearch(info) {

            this.searchData = {
                buyer: '', //买家名称
                buyerType: '', //买家类型
                orderNo: '', // 查询的订单编号
                fromDate: '',
                toDate: '',
                orderStatus: [],
                orderWay: []
            }
            this.$refs['bookmarkAutoSuggest'].searchQuery = '';
        }

    }
};
</script>

<style lang="scss" scoped>
@import '../order.scss';

.order-box-left {
    background: rgb(255, 255, 255);
    width: 170px;
    height: 100%;

    .top-search {
        @include flex-mixin(row, center, space-between);
        display: block !important;
        height: 80px;
        border-bottom: 1px solid rgb(235, 234, 234);
    }

    /deep/ .v-select {
        width: 100%;
    }

    .order-number {
        height: 87px;
    }

    .timer {
        width: 100%;

        .flatpickr-input {
            width: 100%;
        }
    }

    .collapse {
        /deep/ .vs-collapse-item {
            border: none !important;

            .vs-collapse-item--header {
                padding: 12px 0 !important;
            }

            .con-content--item {
                padding: 0;
            }
        }
    }

    .item {
        padding: 12px;
    }

    .label {
        font-size: 14px;
        font-weight: 500;
        color: #14151b;
    }

    .form-item {
        width: 100%;
        height: 38px;
    }
}

.search-btn {
    padding: 5px 8px !important;
    width: 46%;
    margin: 0 2%;
}
</style>
